/* eslint-disable max-len */
import { MasterQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig/models";

import * as questionIds from "./questionIds";

export const masterConfig: MasterQuestionConfig[] = [
    {
        id: questionIds.Title,
        questionText: "Title",
        canBeDisabled: true
    },
    {
        id: questionIds.FirstName,
        questionText: "First Name",
        canBeDisabled: false
    },
    {
        id: questionIds.LastName,
        questionText: "Last Name",
        canBeDisabled: false
    },
    {
        id: questionIds.Gender,
        questionText: "Gender",
        canBeDisabled: true
    },
    {
        id: questionIds.Dob,
        questionText: "Date of Birth",
        canBeDisabled: false
    },
    {
        id: questionIds.AddressLine1,
        questionText: "Address Line 1",
        canBeDisabled: true
    },
    {
        id: questionIds.AddressLine2,
        questionText: "Address Line 2",
        canBeDisabled: true
    },
    {
        id: questionIds.City,
        questionText: "City",
        canBeDisabled: true
    },
    {
        id: questionIds.County,
        questionText: "County",
        canBeDisabled: true
    },
    {
        id: questionIds.Postcode,
        questionText: "Postcode",
        canBeDisabled: false
    },
    {
        id: questionIds.MobilePhone,
        questionText: "Mobile Telephone",
        canBeDisabled: true
    },
    {
        id: questionIds.HomePhone,
        questionText: "Home Telephone",
        canBeDisabled: true
    },
    {
        id: questionIds.HasDisability,
        questionText: "Do you have any illness/impairment/disability (physical or psychological including learning disability/difficulties such as dyslexia and dyspraxia) which may impair your ability to undertake effectively the duties of your proposed position? If yes, please give details below.",
        canBeDisabled: true
    },
    {
        id: questionIds.EverHadDisability,
        questionText: "Have you ever had any illness/impairment/disability which may have been caused or made worse by your work? If yes, please give details below.",
        canBeDisabled: true
    },
    {
        id: questionIds.HavingTreatment,
        questionText: "Are you having, or waiting for treatment (including medications) or investigations at present? If yes, please give details of condition, treatment and dates, below.",
        canBeDisabled: true
    },
    {
        id: questionIds.HasConditionRequiringAdjustment,
        questionText: "Do you have a health condition or disability that may require adjustments to your work or workplace to help you do your proposed job role?  If yes, please give details below.",
        canBeDisabled: true
    },
    {
        id: questionIds.FurtherDetails,
        questionText: "If you have answered Yes to any of the questions above please provide further details here",
        canBeDisabled: true
    },
    {
        id: questionIds.CanProvideMmrVaccineEvidence,
        questionText: "Can you provide evidence of having received 2 doses of MMR Vaccine",
        canBeDisabled: true
    },
    {
        id: questionIds.MmrVaccineEvidence,
        questionText: "Please upload your evidence",
        canBeDisabled: true
    },
    {
        id: questionIds.CanProvideMeaslesRubellaTestEvidence,
        questionText: "Can you provide evidence of a positive antibody test to measles and rubella (Blood test)",
        canBeDisabled: true
    },
    {
        id: questionIds.MeaslesRubellaTestEvidence,
        questionText: "Please upload your evidence",
        canBeDisabled: true
    },
    {
        id: questionIds.CanProvideBcgCheckEvidence,
        questionText: "Can you provide evidence of a BCG Scar Check or Mantoux Test and result or BCG Vaccine",
        canBeDisabled: true
    },
    {
        id: questionIds.BcgCheckEvidence,
        questionText: "Please upload your evidence",
        canBeDisabled: true
    },
    {
        id: questionIds.CanProvideVaricellaEvidence,
        questionText: "Can you provide evidence of having received 2 doses of Varicella vaccine/positive antibody test to varicella (Blood test)",
        canBeDisabled: true
    },
    {
        id: questionIds.VaricellaEvidence,
        questionText: "Please upload your evidence",
        canBeDisabled: true
    },
    {
        id: questionIds.CanProvideHepatitisBImmunityEvidence,
        questionText: "Can you provide evidence of Hepatitis B Immunity - evidence of an antibody titre levels (Blood test)",
        canBeDisabled: true
    },
    {
        id: questionIds.HepatitisBImmunityEvidence,
        questionText: "Please upload your evidence",
        canBeDisabled: true
    },
    {
        id: questionIds.HadChickenPox,
        questionText: "Have you ever had chicken pox, or do you have documented evidence of immunity to Varicella?",
        canBeDisabled: true
    },
    {
        id: questionIds.HadChildhoodVaccinations,
        questionText: "As far as you are aware, have you had all your routine childhood vaccinations as per the UK vaccination schedule, including tetanus, polio, diphtheria and pertussis?",
        canBeDisabled: true
    },
    {
        id: questionIds.HaveCoughMoreThan3Weeks,
        questionText: "Do you have a cough which has lasted more than 3 weeks",
        canBeDisabled: true
    },
    {
        id: questionIds.HaveUnexplainedWeightLoss,
        questionText: "Do you have unexplained weight loss",
        canBeDisabled: true
    },
    {
        id: questionIds.HaveUnexplainedFever,
        questionText: "Do you have unexplained fever",
        canBeDisabled: true
    },
    {
        id: questionIds.HaveTuberculosis,
        questionText: "Do you have Tuberculosis or contact with Tuberculosis",
        canBeDisabled: true
    },
    {
        id: questionIds.TravelToTbAreas,
        questionText: "Do you regularly travel abroad to countries that carry a high TB risk?",
        canBeDisabled: true
    },
    {
        id: questionIds.LivedContinuouslyInUk,
        questionText: "Have you lived in the UK continuously for the last 5 years?",
        canBeDisabled: true
    },
    {
        id: questionIds.CountriesLivedIn,
        questionText: "If No please list the countries that you have lived in below",
        canBeDisabled: true
    },
    {
        id: questionIds.CanProvideHepatitisBStatus,
        questionText: "Can you provide evidence of your Hepatitis B Status?",
        canBeDisabled: true
    },
    {
        id: questionIds.HepatitisBStatusEvidence,
        questionText: "Please upload your evidence",
        canBeDisabled: true
    },
    {
        id: questionIds.CanProvideHepatitisCStatus,
        questionText: "Can you provide evidence of your Hepatitis C Status?",
        canBeDisabled: true
    },
    {
        id: questionIds.HepatitisCStatusEvidence,
        questionText: "Please upload your evidence",
        canBeDisabled: true
    },
    {
        id: questionIds.CanProvideHivStatus,
        questionText: "Can you provide evidence of your HIV Status?",
        canBeDisabled: true
    },
    {
        id: questionIds.HivStatusEvidence,
        questionText: "Please upload your evidence",
        canBeDisabled: true
    },
    {
        id: questionIds.HadHepatitisB,
        questionText: "Have you ever had or been tested positive for Hepatitis B?",
        canBeDisabled: true
    },
    {
        id: questionIds.HadHepatitisC,
        questionText: "Have you ever had or been tested positive for Hepatitis C?",
        canBeDisabled: true
    },
    {
        id: questionIds.HadHiv,
        questionText: "Have you ever had or been tested positive for HIV?",
        canBeDisabled: true
    },
    {
        id: questionIds.HadHighRiskFromHep,
        questionText: "Have you any reason to believe that you have ever been at high risk from exposure to Hep B, Hep C or HIV?",
        canBeDisabled: true
    },
    {
        id: questionIds.HadTyphoid,
        questionText: "Have you ever had Typhoid fever/para-typhoid fever?",
        canBeDisabled: true
    },
    {
        id: questionIds.HadBowelDisorders,
        questionText: "Have you ever had Bowel disorders e.g. dysentery, persistent diarrhoea?",
        canBeDisabled: true
    },
    {
        id: questionIds.HadTuberculosis,
        questionText: "Have you ever had Tuberculosis?",
        canBeDisabled: true
    },
    {
        id: questionIds.HadAsthmaChestInfection,
        questionText: "Have you ever had Asthma or any other chest infection?",
        canBeDisabled: true
    },
    {
        id: questionIds.HadRecurringSkinDisorders,
        questionText: "Have you ever had recurring skin disorders?",
        canBeDisabled: true
    },
    {
        id: questionIds.HadAllergicReactions,
        questionText: "Have you ever had allergic reactions (including to nuts)?",
        canBeDisabled: true
    },
    {
        id: questionIds.HadBackNeckArmWristProblems,
        questionText: "Have you ever had persistent back, neck, arm or wrist problems?",
        canBeDisabled: true
    },
    {
        id: questionIds.HadDeafnessDefectiveVision,
        questionText: "Have you ever had deafness or defective vision?",
        canBeDisabled: true
    },
    {
        id: questionIds.HadBlackoutsDizzySpells,
        questionText: "Have you ever had blackouts or dizzy spells?",
        canBeDisabled: true
    },
    {
        id: questionIds.HadRecentSkinInfection,
        questionText: "Within the last 2 weeks have you suffered a skin infection?",
        canBeDisabled: true
    },
    {
        id: questionIds.HadRecentDiarrhoeaVomiting,
        questionText: "Within the last 2 weeks have you suffered diarrhoea and/or vomiting?",
        canBeDisabled: true
    },
    {
        id: questionIds.HadRecentEarEyeGumInfection,
        questionText: "Within the last 2 weeks have you suffered an infection involving ears, eyes or gums?",
        canBeDisabled: true
    },
    {
        id: questionIds.HadTyphoidContact,
        questionText: "Within the last 2 weeks have you had contact with anyone who may have had typhoid or paratyphoid fever?",
        canBeDisabled: true
    },
    {
        id: questionIds.OngoingSymptomsAndTreatments,
        questionText: "If you have answered yes to any of the above, please give details including ongoing symptoms and any treatment prescribed",
        canBeDisabled: true
    },
    {
        id: questionIds.PrivacyStatementConfirmation,
        questionText: "I can confirm that I have been provided with access to the <a href=\"https://tphealth.co.uk/privacy-statement\" target=\"_blank\" rel=\"noopener noreferrer\">Privacy Statement</a> which clearly explains in detail how, where and when my personal and health data will be processed",
        canBeDisabled: true
    },
    {
        id: questionIds.TeamPreventProcessPersonalInfoConfirmation,
        questionText: "In ticking this box, I understand that Optima Health to process will process my personal and Health related information for Occupational Health Purposes",
        canBeDisabled: true
    },
    {
        id: questionIds.InformationHeldSecurelyConfirmation,
        questionText: "I understand that my information will be held securely and if I wish to gain access to my medical information I can do so by requesting access in writing to Optima Health",
        canBeDisabled: true
    },
    {
        id: questionIds.FitnessToWorkProvidedToEmployerConfirmation,
        questionText: "I understand that information on my fitness to work will be provided to my employer",
        canBeDisabled: true
    },
    {
        id: questionIds.AnswersTrueConfirmation,
        questionText: "I declare that the answers to all the above questions true. I understand that if I fail to disclose information or make a false statement that this may lead to retraction of my job offer or termination of my contract of employment.",
        canBeDisabled: true
    },
    {
        id: questionIds.Covid19RiskAssessmentStatementOfUnderstanding,
        questionText: "Please select to proceed",
        canBeDisabled: true
    },
    {
        id: questionIds.Age,
        questionText: "Age",
        canBeDisabled: true
    },
    {
        id: questionIds.GenderAtBirth,
        questionText: "Gender at Birth",
        canBeDisabled: true
    },
    {
        id: questionIds.Ethnicity,
        questionText: "Ethnicity",
        canBeDisabled: true
    },
    {
        id: questionIds.Asthma,
        questionText: "Asthma",
        canBeDisabled: true
    },
    {
        id: questionIds.Diabetes,
        questionText: "Diabetes",
        canBeDisabled: true
    },
    {
        id: questionIds.ChronicKidneyDisease,
        questionText: "Chronic Kidney Disease",
        canBeDisabled: true
    },
    {
        id: questionIds.CancerOtherThanLeukaemiaLymphomaOrMyeloma,
        questionText: "Cancer other than leukaemia, lymphoma or myeloma",
        canBeDisabled: true
    },
    {
        id: questionIds.LeukaemiaLymphomaOrMyeloma,
        questionText: "Leukaemia, lymphoma or myeloma",
        canBeDisabled: true
    },
    {
        id: questionIds.Heart,
        questionText: "Heart",
        canBeDisabled: true
    },
    {
        id: questionIds.OtherChronicRespiratorydDisease,
        questionText: "Other chronic respiratory disease",
        canBeDisabled: true
    },
    {
        id: questionIds.Hypertension,
        questionText: "Hypertension",
        canBeDisabled: true
    },
    {
        id: questionIds.CerebrovascularDisease,
        questionText: "Cerebrovascular disease",
        canBeDisabled: true
    },
    {
        id: questionIds.LiverDisease,
        questionText: "Liver disease",
        canBeDisabled: true
    },
    {
        id: questionIds.ChronicNeurologicalDiseaseOtherThanStrokeOrDementia,
        questionText: "Chronic Neurological disease other than stroke or dementia",
        canBeDisabled: true
    },
    {
        id: questionIds.OrganTransplant,
        questionText: "Organ transplant",
        canBeDisabled: true
    },
    {
        id: questionIds.SpleenDiseases,
        questionText: "Spleen diseases",
        canBeDisabled: true
    },
    {
        id: questionIds.RheumatoidLupusPsoriasis,
        questionText: "Rheumatoid / lupus / psoriasis",
        canBeDisabled: true
    },
    {
        id: questionIds.OtherImmunosuppresiveCondition,
        questionText: "Other immunosuppresive condition",
        canBeDisabled: true
    },
    {
        id: questionIds.Covid19VaccineStatus,
        questionText: "Please tick the statement below which best describes your current COVID-19 vaccination status",
        canBeDisabled: true
    },
    {
        id: questionIds.Covid19FirstVaccineStatus,
        questionText: "1st COVID-19 Vaccine received",
        canBeDisabled: true
    },
    {
        id: questionIds.Covid19FirstVaccineDate,
        questionText: "Date",
        canBeDisabled: true
    },
    {
        id: questionIds.Covid19FirstVaccineType,
        questionText: "Vaccine Type",
        canBeDisabled: true
    },
    {
        id: questionIds.Covid19SecondVaccineStatus,
        questionText: "2nd COVID-19 Vaccine received",
        canBeDisabled: true
    },
    {
        id: questionIds.Covid19SecondVaccineDate,
        questionText: "Date",
        canBeDisabled: true
    },
    {
        id: questionIds.Covid19SecondVaccineType,
        questionText: "Vaccine Type",
        canBeDisabled: true
    },
    {
        id: questionIds.Covid19VaccineDeclaration,
        questionText: "I can confirm that should my employer or teaching academy ask if at the time of completing this questionnaire I had received a first or second vaccination then I am happy for Optima Health to confirm my COVID-19 vaccination status to my employer or teaching academy.",
        canBeDisabled: true
    },
    {
        id: questionIds.Bmi,
        questionText: "Calculated BMI",
        canBeDisabled: true
    },
    {
        id: questionIds.CovidRiskAge,
        questionText: "CovidRiskAge",
        canBeDisabled: true
    },
    {
        id: questionIds.CovidRiskGroup,
        questionText: "Risk",
        canBeDisabled: true
    },
    {
        id: questionIds.CovidFinalRiskGroup,
        questionText: "Risk",
        canBeDisabled: true
    },
    {
        id: questionIds.CovidVaccinationStatus,
        questionText: "Can you provide documentary evidence of having received 1 or 2 covid-19 vaccinations?  Evidence should be in the form of screenshot from the NHS app, a downloaded copy of your vaccination history from the NHS App, a copy of the NHS Covid Pass letter, a letter from your GP or letter from your previous Occupational Health Department.  The evidence provided must include your name and date of birth.",
        canBeDisabled: true
    },
    {
        id: questionIds.CovidVaccinationDate,
        questionText: "What date is your vaccine booked for?",
        canBeDisabled: true
    },
    {
        id: questionIds.CovidVaccinationEvidenceRequiredConsent,
        questionText: "I can confirm that I understand evidence of covid-19 vaccination status is required for this role",
        canBeDisabled: true
    },
    {
        id: questionIds.CovidVaccinationEvidenceSharingConsent,
        questionText: "I can confirm my consent to Occupational Health sharing my covid-19 vaccination history including dates of vaccination with my employer",
        canBeDisabled: true
    },
    {
        id: questionIds.CovidVaccineEvidence,
        questionText: "Please upload your evidence",
        canBeDisabled: true
    }
];
/* eslint-enable max-len */
